export const secretCodeFormatter = (code) => {
  return code.match(/.{1,5}/g).join("-");
};

